import * as React from 'react'
import cx from 'classnames'
import { observer } from 'mobx-react'
import styles from './AvatarSelector.sass'
import Avatar, { AvatarSubject } from 'components/Avatar'
import FileButton from 'components/FileButton'
import Icon from 'components/Icon'
import Spinner from 'components/Spinner'

interface AvatarSelectorProps {
  subject: AvatarSubject
  size?: number
  isUploading?: boolean
  readOnly?: boolean

  onSelectNewFile?(file: File): unknown
}

export default observer(function AvatarSelector({
  subject,
  isUploading,
  readOnly,
  onSelectNewFile,
  size = 48,
}: AvatarSelectorProps) {
  return (
    <div className={cx(styles.root, isUploading && styles.pending)}>
      <div className={styles.avatar}>
        <Avatar size={size} subject={subject} />
      </div>
      {!readOnly && (
        <div className={cx(styles.avatarInput)}>
          <Icon name="camera" color="#fff" />
          <FileButton
            overlay
            onChange={(files: FileList) => onSelectNewFile?.(files[0])}
            accept=".png,.jpg,.jpeg"
          />
        </div>
      )}
      <div className={styles.spinner}>
        <Spinner size={size + 8} thickness={2} />
      </div>
    </div>
  )
})
